<template>
  <div class="row">
        <vx-tooltip color="primary" text="Quick View" position="left">
    <vs-button color="primary" type="flat"   icon-pack="feather" icon="icon-edit" @click="open()" ></vs-button>
  </vx-tooltip>
  <vx-tooltip color="primary" text="Delete" position="left">
    <vs-button color="danger" type="flat"   icon-pack="feather" icon="icon-trash" @click="open3()" ></vs-button>
  </vx-tooltip>
  </div>
</template>


<script>


export default {
  data () {
    return {
      data:{}
    }
  },
  methods:{
    open () {
      this.$parent.$parent.$parent.editTemplate(this.data)
    },
    open2 () {
    //   this.$parent.$parent.navigateToVehicleView(this.data.id)
    },
    open3 () {
      this.$parent.$parent.$parent.postData('delete',this.data)
    }
  }
}
</script>
